// Missing Reads Dashboard Bar Chart

import React from "react";
import ReactECharts from "echarts-for-react";

const MissingReadsDashboardBarChart: React.FC = () => {
  const options = {
    xAxis: {
      type: "category",
      data: ["Critical", "Najor", "Minor"],
      axisLabel: {
        color: "#181B25",
        fontSize: 11,
        fontWeight: 400,
      },
    },
    yAxis: [
      {
        type: "value",
        axisLabel: {
          formatter: "{value}",
          color: "#5F6368",
          fontSize: 9,
          fontWeight: 400,
          lineHeight: 11,
          letterSpacing: 0.2,
        },
      },
    ],
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 1,
      borderColor: "#181B25",
      axisPointer: { type: "shadow" },
      formatter: (params: any) => {
        const { name, value } = params[0];
        return `
          <div style="padding: 5px 10px; align-items:center; border-radius: 3px; color: #ffffff ;">
          ${name} : ${value}
          </div>
        `;
      },
    },
    series: [
      {
        data: [12, 12, 24],
        type: "bar",
        yAxisIndex: 0,
        itemStyle: {
          color: "#1976d2",
        },
        barWidth: "50%",
      },
    ],
    grid: {
      left: "3%",
      right: "3%",
      bottom: "3%",
      containLabel: true,
    },
  };

  return <ReactECharts option={options} />;
};

export default MissingReadsDashboardBarChart;
